import React, { useEffect, useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Scrollbar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const triggerPoint = window.innerHeight * 0.4; // 40vh

      setVisible(scrollPosition > triggerPoint);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <ul
      style={{
        position: "fixed",
        right: "25px",
        bottom: "30px",
        zIndex: 9999,
        listStyle: "none",
        margin: 0,
        padding: 0,
      }}
    >
      <li>
        <AnchorLink href="#scrool">
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              backgroundColor: "#ffcc29",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
              transition: "all 0.3s ease",
            }}
          >
            <i
              className="far fa-arrow-up"
              style={{
                color: "#000",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            ></i>
          </div>
        </AnchorLink>
      </li>
    </ul>
  );
};

export default Scrollbar;
